import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';


export default class YouTubeModal {

  constructor() {

    $('.cta--video').click( (e) => { this.handleClick(e); });
    $('.overlay__close.youtube').click( (e) => { this.close(e); } );

    this.yt = new YouTubeEmbedAPI();

    this.videoid = '';

  }

  handleClick(e) {
    e.preventDefault();

    if ($('section.youtube').hasClass('is-active')) {
      this.close();
    } else {
      this.open(e);
    }
  }


  open(e) {
    console.log($(e.currentTarget));
    $('section.youtube').addClass('is-active');
    $('section.youtube .modalAnchor').focus();
    $('section.youtube .overlay__close').blur(() => {
      $('section.youtube .modalAnchor').focus();
    });

    this.videoid = $(e.currentTarget).data('videoid');

    ga('send', 'event', 'YouTube Modal', 'open', this.videoid);

    this.yt.createPlayer(this.videoid);

  }

  close() {
    $('section.youtube').css('visibility', 'visible');
    $('section.youtube').removeClass('is-active');
    $('section.youtube .overlay__close').off('blur');

    ga('send', 'event', 'YouTube Modal', 'close', this.videoid);

    setTimeout( () => {
      this.resetYouTube();
    }, 500 );
  }

  resetYouTube() {
    this.yt.destroyPlayer();
    $('section.youtube').css('visibility', '');
  }

}



// WEBPACK FOOTER //
// ./js/modules/YouTubeModal.js